<template>
    <div
        class="input-textarea__outer"
        :class="[{ dirty: isDirty, clean: isClean }]"
    >
        <label class="input-textarea__label">
            {{ labelText }}
        </label>
        <div class="input-textarea__wrapper">
            <textarea
                type="text"
                ref="input"
                :value="value"
                @input="updateInput()"
                :placeholder="placeholder"
                :required="required"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: ['value', 'placeholder', 'required', 'label'],
    computed: {
        labelText() {
            if (this.label) {
                return this.label;
            }
            return this.placeholderText;
        },
        placeholderText() {
            if (this.required) {
                return `${this.placeholder}*`;
            }
            return this.placeholder;
        },
        isDirty() {
            return typeof this.value !== 'undefined' && this.value;
        },
        isClean() {
            return typeof this.value === 'undefined' || !this.value;
        },
    },
    methods: {
        updateInput() {
            this.$emit('input', this.$refs.input.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.input-textarea__wrapper {
    border: 1px solid #bcb4b0;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    position: relative;

    &:after {
        transition: box-shadow 0.3s ease-in;
    }

    textarea {
        border: 0;
        width: 100%;
        height: 150px;
        line-height: 40px;
        padding: 0;
        font-weight: 500;
        color: #4e3a30;
        resize: none;
        &::-webkit-input-placeholder {
            color: rgba(78, 58, 48, 0.6);
        }
        &:focus {
            outline: 0;
            &::-webkit-input-placeholder {
                opacity: 0;
            }
        }
    }

    &.error {
        border-color: #e3342f;
    }

    &.input--high {
        textarea {
            padding-top: 18px;
            font-size: 20px;
        }
    }

    &:focus-within {
        border-color: transparent;
        &:after {
            content: '';
            position: absolute;
            border-radius: 4px;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            box-shadow: inset 0 0 0 2px #c8532b;
            pointer-events: none;
        }
    }
}

.input-textarea__outer {
    position: relative;
    padding-top: 5px;
    .input-textarea__label {
        display: inline-block;
        position: absolute;
        top: 5px;
        left: 10px;
        padding-left: 2px;
        padding-right: 6px;
        background-color: #fff;
        transform: translateY(-50%);
        font-size: 14px;
        color: rgba(78, 58, 48, 1);
        z-index: 1;
    }

    &.clean {
        .input-textarea__label {
            display: none;
        }
        &:focus-within {
            .input-textarea__label {
                display: inline-block;
            }
        }
    }

    &:focus-within {
        .input-textarea__label {
            color: #c8532b;
        }
    }

    &.input--high,
    .input-textarea__wrapper {
        font-size: 20px;
    }
}
</style>
